import { dadosReais } from './reais'
import { dadosPreview } from './preview'

/**
 * Camada de dados do aplicativo.
 *
 * Duas implementações com a mesma forma:
 *
 * | Implementação | Origem | Quando |
 * |---------------|--------|--------|
 * | `reais.ts`    | API do FastAPI | **produção** (padrão) |
 * | `preview.ts`  | dumps e `autocomex.db` | quando `VITE_PREVIEW=1` |
 *
 * As telas importam só daqui e não sabem qual está em uso.
 *
 * 🔴 **O padrão é a API real.** Se o preview fosse o padrão, um build de produção
 * distraído subiria com dado falso — que é pior que não subir, porque parece
 * funcionar. Para ver o preview é preciso pedir explicitamente:
 *
 * ```
 * VITE_PREVIEW=1 npm run dev     # dados de exemplo
 * npm run dev                    # API real em /api (proxy do Vite)
 * ```
 */

const usarPreview = import.meta.env.VITE_PREVIEW === '1'

export const dados = usarPreview ? dadosPreview : dadosReais

/** Verdadeiro quando a tela está exibindo dado de exemplo. */
export const EM_PREVIEW = usarPreview
